import React, { useState, useEffect } from "react";
import { paper, Point, Size, Rectangle, Path, Segment, PointText } from "paper";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import DownloadMenu from "../../shared/DownloadMenu";
import { drawTunnelHeader } from "../../shared/tunnelHeader";
const Debugoutput = (props) => {
  let multiplier = 5;
  let padding = 110;
  let tralength = 80;
  let D = parseInt(props.dimensions.direction);
  let height = parseInt(props.dimensions.height) * multiplier;
  let width = parseInt(props.dimensions.width) * multiplier;
  let hw = parseInt(props.dimensions.hw) * multiplier;
  let WS = parseInt(props.dimensions.widthspl) * multiplier;
  let P2 = parseFloat(props.dimensions.p2);
  let P4 = parseFloat(props.dimensions.p4);
  let P5 = parseFloat(props.dimensions.p5);
  if(Math.min(P2, P4, P5)<40)
  {
    tralength = Math.min(P2, P4, P5)*2
  }
  let length =
    (parseInt(Math.max(P2, P4, P5) - Math.min(P2, P4, P5)) + tralength) *
    multiplier;
  let Whalf = WS / 2;
  let HC = height - hw;
  let r = (Math.pow(Whalf, 2) + Math.pow(HC, 2)) / (2 * HC);
  let Theta = toDegree(Math.atan((r - HC) / Whalf));

  let text;
  let i = 0;
  let Arc = (Math.PI * r) / 2 - ((Math.PI * r) / 2) * (Theta / 90);
  let ArcFull = Arc * 2;
  let HWn = height - r;
  let scalearr = [];
  let usrvar = [],
    TanAlpha,
    Pmid,
    Beta,
    BetaH,
    ApDir,
    ApDirOrig,
    Dir,
    Alpha,
    Incl,
    XP3,
    X1,
    XPmid;
  let tracedimensions = props.dimensions;
  let Ymax = padding + 2 * (hw + Arc);
  function toRadians(angle) {
    return angle * (Math.PI / 180);
  }
  function toDegree(radian) {
    return radian * (180 / Math.PI);
  }
  const [uservariables, setUserVariables] = useState([]);
  useEffect(() => {
    WS = WS / multiplier;
    HC = HC / multiplier;
    if (P2 > P4) {
      TanAlpha = WS / (P2 - P4);
      Pmid = P4 + (P2 - P4) / 2;
      Beta = toDegree(Math.atan(HC / Math.abs(Pmid - P5)));
    } else {
      TanAlpha = WS / (P4 - P2);
      Pmid = P2 + (P4 - P2) / 2;
      Beta = toDegree(Math.atan(HC / Math.abs(P5 - Pmid)));
    }
    Alpha = toDegree(Math.atan(TanAlpha));

    let Dopp = D > 180 ? D - 180 : D + 180;
    if (Pmid > P5) {
      ApDir = D;
    } else {
      ApDir = Dopp;
    }

    // Beta and ApDir computed above are the *post-inclination* values
    // (what the log actually shows). For the trace rendering we keep them as-is,
    // but to back-compute true Dir / Amt we reverse the inclination correction
    // applied during plotting.
    Incl = parseFloat(tracedimensions.inclination) || 0;
    const I = Incl;
    BetaH = Beta;
    ApDirOrig = ApDir;
    if (I !== 0) {
      if (ApDir === Dopp) {
        if (Beta < I) {
          // Forward inclination flipped ApDir from D → Dopp
          BetaH = I - Beta;
          ApDirOrig = D;
        } else {
          BetaH = Beta - I;
          // ApDirOrig stays Dopp
        }
      } else {
        // ApDir === D
        if (Beta < 90 - I) {
          BetaH = Beta + I;
          // ApDirOrig stays D
        } else {
          // Forward inclination flipped ApDir from Dopp → D
          BetaH = 180 - I - Beta;
          ApDirOrig = Dopp;
        }
      }
    }

    // Note: in the flip case, the inclination correction is not injective —
    // two Dir values (one in each hemisphere of ApDirOrig) can produce the
    // same trace on the log. We back-compute Dir using the recovered
    // ApDirOrig and the measured P2/P4 side; the alternate candidate is
    // Dir ± 2·(90-Alpha) in the same hemisphere.
    if (P2 > P4) {
      Dir = ApDirOrig - (90 - Alpha);
    } else {
      Dir = ApDirOrig + (90 - Alpha);
    }
    if (Dir < 0) {
      Dir = 360 + Dir;
    }
    if (Dir > 360) {
      Dir = Dir - 360;
    }

    let Dirstring = String(Math.round(Dir)).padStart(3, "0");

    let TanAmt = Math.tan(toRadians(BetaH)) / Math.sin(toRadians(Alpha));
    let Amt = toDegree(Math.atan(TanAmt));
    let Amtstring = String(Math.round(Amt)).padStart(2, "0");
    WS = WS * multiplier;
    HC = HC * multiplier;
    // usrvar['WS'] = WS;
    usrvar["Discontinuity Dip"] = "N" + Dirstring + "/" + Amtstring;
    usrvar["Tunnel Direction"] = D;
    usrvar["Tunnel Inclination"] = I;
    usrvar["Ch. Right SPL"] = P2;
    usrvar["Ch. Left SPL"] = P4;
    usrvar["Ch. Centerline"] = P5;
    usrvar["Alpha"] = Math.round(Alpha);
    usrvar["Beta (on log)"] = Math.round(Beta);
    usrvar["Beta (horizontal)"] = Math.round(BetaH);
    setUserVariables(usrvar);
  }, []);
  useEffect(() => {
    if (!props.showdebug) {
      paper.setup("paper-canvas");
      creategraph();
    }
  }, [props.dimensions, props.showdebug]);
  const creategraph = () => {
    paper.project.clear();
    let width = length + 450;
    let height = Math.max(width / 2, Ymax + 150);
    paper.view.viewSize = new Size(width, height);
    draw();
    paper.view.draw();
  };
  const createScale = () => {
    for (i = padding; i <= length + padding; i += multiplier * 10) {
      text = new PointText(new Point(i, Ymax + 15));
      text.justification = "center";
      text.fillColor = "black";
      text.content = Math.round(
        (i - padding) / multiplier + Math.min(P2, P4, P5) - tralength / 2
      );
      scalearr.push([i, Ymax + 10]);
      scalearr.push([i, Ymax]);

      if (i + multiplier * 10 <= length + padding) {
        for (let j = 1; j <= 9; j++) {
          scalearr.push([i + multiplier * j, Ymax]);
          scalearr.push([i + multiplier * j, Ymax + 5]);
          scalearr.push([i + multiplier * j, Ymax]);
        }
        scalearr.push([i + multiplier * 10, Ymax]);
      }
    }
    new Path({
      segments: scalearr,
      strokeColor: "black",
      strokeWidth: 1,
    });
    if (tracedimensions.iscrown) {
      Ymax = padding + 2 * (hw + Arc);
    }
  };
  const createLog = () => {
    let style = {
      fillColor: "white",
      strokeColor: "black",
      strokeWidth: 1,
    };
    var path = new Path.Rectangle(
      new Rectangle(
        new Point(padding, padding),
        new Size(length, 2 * (hw + Arc))
      )
    );
    path.style = style;
    var path1 = new Path.Rectangle(
      new Rectangle(new Point(padding, padding + hw), new Size(length, 2 * Arc))
    );
    path1.style = style;

    var path2 = new Path.Rectangle(
      new Rectangle(
        path.bounds.rightCenter.add([HC, -width / 2]),
        new Size(hw, width)
      )
    );
    path2.style = style;
    var path21 = new Path.Arc(
      path2.bounds.topLeft,
      path.bounds.rightCenter,
      path2.bounds.bottomLeft
    );
    path21.style = style;

    var path3 = new Path.Line(path.bounds.leftCenter, path2.bounds.rightCenter);
    path3.strokeColor = "black";
    path3.dashArray = [4, 10];
    if (!tracedimensions.iscrown) {
      var path4 = new Path(
        new Segment(path.bounds.topRight),
        new Segment(path2.bounds.topRight)
      );
      path4.strokeColor = "black";
      path4.dashArray = [14, 5];
      var path5 = new Path(
        new Segment(path.bounds.bottomRight),
        new Segment(path2.bounds.bottomRight)
      );
      path5.strokeColor = "black";
      path5.dashArray = [14, 5];
      var path6 = new Path(
        new Segment(path1.bounds.topRight),
        new Segment(path2.bounds.topLeft)
      );
      path6.strokeColor = "black";
      path6.dashArray = [14, 5];
      var path7 = new Path(
        new Segment(path1.bounds.bottomRight),
        new Segment(path2.bounds.bottomLeft)
      );
      path7.strokeColor = "black";
      path7.dashArray = [14, 5];
    } else {
      var path4 = new Path(
        new Segment(path.bounds.topRight),
        new Segment(path2.bounds.topLeft)
      );
      path4.strokeColor = "black";
      path4.dashArray = [3, 5];
      var path5 = new Path(
        new Segment(path.bounds.bottomRight),
        new Segment(path2.bounds.bottomLeft)
      );
      path5.strokeColor = "black";
      path5.dashArray = [3, 5];
    }
    text = new PointText(path.bounds.topLeft.add([-5, 5]));
    text.justification = "right";
    text.fillColor = "black";
    text.content = "Left Invert";
    text = new PointText(path.bounds.bottomLeft.add([-5, 5]));
    text.justification = "right";
    text.fillColor = "black";
    text.content = "Right Invert";
    text = new PointText(path1.bounds.topLeft.add([-5, 5]));
    text.justification = "right";
    text.fillColor = "black";
    text.content = "Left Spring Level";
    text = new PointText(path1.bounds.bottomLeft.add([-5, 5]));
    text.justification = "right";
    text.fillColor = "black";
    text.content = "Right Spring Level";

    text = new PointText(path.bounds.leftCenter.add([-5, 5]));
    text.justification = "right";
    text.fillColor = "black";
    text.content = "Centerline";
    drawTunnelHeader({ Path, Point, PointText, bounds: path.bounds, direction: tracedimensions.direction, inclination: tracedimensions.inclination, style });
  };
  const createTrace = () => {
    let style = {
      fillColor: "transparent",
      strokeColor: "black",
      strokeWidth: 1,
    };
    let traceunion = [];
    let X1;
    let H = [],
      XP = [],
      YP = [],
      XP5 = [],
      YP5 = [],
      XP3,
      Dopp;
    if (D >= 0 && D <= 180) {
      Dopp = D + 180;
    } else {
      Dopp = D - 180;
    }
    let Diff = D - Dir;
    let XP2 =
      P2 * multiplier +
      padding -
      (Math.min(P2, P4, P5) - tralength / 2) * multiplier;
    let TanBeta = Math.tan(toRadians(Beta));
    if (ApDir === D) {
      X1 = XP2 + hw / TanBeta;
    } else {
      X1 = XP2 - hw / TanBeta;
    }
    if (ApDir === D) {
      if ((Diff > -360 && Diff < -270) || (Diff > 0 && Diff < 90)) {
        XP3 = X1 - width / TanAlpha;
        XPmid = X1 - Math.abs(X1 - XP3) / 2;
      } else {
        XP3 = X1 + width / TanAlpha;
        XPmid = X1 + Math.abs(X1 - XP3) / 2;
      }
    } else {
      Diff = Dopp - Dir;
      if ((Diff > -360 && Diff < -270) || (Diff > 0 && Diff < 90)) {
        XP3 = X1 - width / TanAlpha;
        XPmid = X1 - Math.abs(X1 - XP3) / 2;
      } else {
        XP3 = X1 + width / TanAlpha;
        XPmid = X1 + Math.abs(X1 - XP3) / 2;
      }
    }
    let Point1 = new Point(X1, Ymax);
    let Point2 = new Point(XP2, Ymax - hw);
    let Point4 = new Point(XP3 - hw / TanBeta, Ymax - (hw + ArcFull));
    if (ApDir !== D) {
      Point4 = new Point(XP3 + hw / TanBeta, Ymax - (hw + ArcFull));
    }
    traceunion.push([Point1.x, Point1.y]);
    traceunion.push([Point2.x, Point2.y]);
    //right crown
    for (let n = Theta; n <= 90; n++) {
      H[n] = r * Math.sin(toRadians(n));
      if (ApDir === D) {
        if (Point2.x > Point4.x) {
          XP[n] = X1 - Math.abs(X1 - XPmid) * ((n - Theta) / (90 - Theta));
        } else {
          XP[n] = X1 + Math.abs(X1 - XPmid) * ((n - Theta) / (90 - Theta));
        }
        XP5[n] = XP[n] - (H[n] + HWn) / TanBeta;
      } else {
        if (Point2.x > Point4.x) {
          XP[n] = X1 - Math.abs(XPmid - X1) * ((n - Theta) / (90 - Theta));
        } else {
          XP[n] = X1 + Math.abs(XPmid - X1) * ((n - Theta) / (90 - Theta));
        }
        XP5[n] = XP[n] + (H[n] + HWn) / TanBeta;
      }
      YP[n] = Ymax - (hw + Arc * ((n - Theta) / (90 - Theta)));
      YP5[n] = YP[n];
      console.log([XP5[n], XP[n], XPmid, Theta, HWn]);
      traceunion.push([XP5[n], YP5[n]]);
    }
    //left crown
    for (let n = 90; n >= Theta; n--) {
      H[n] = r * Math.sin(toRadians(n));
      if (ApDir === D) {
        if (Point2.x > Point4.x) {
          XP[n] = XP3 + Math.abs(XP3 - XPmid) * ((n - Theta) / (90 - Theta));
        } else {
          XP[n] = XP3 - Math.abs(XP3 - XPmid) * ((n - Theta) / (90 - Theta));
        }
        XP5[n] = XP[n] - (H[n] + HWn) / TanBeta;
      } else {
        if (Point2.x > Point4.x) {
          XP[n] = XP3 + Math.abs(XP3 - XPmid) * ((n - Theta) / (90 - Theta));
        } else {
          XP[n] = XP3 - Math.abs(XP3 - XPmid) * ((n - Theta) / (90 - Theta));
        }
        XP5[n] = XP[n] + (H[n] + HWn) / TanBeta;
      }
      YP[n] = Ymax - (hw + ArcFull - Arc * ((n - Theta) / (90 - Theta)));
      YP5[n] = YP[n];
      traceunion.push([XP5[n], YP5[n]]);
    }
    traceunion.push([Point4.x, Point4.y]);
    traceunion.push([XP3, Ymax - (2 * hw + ArcFull)]);
    let union = new Path({
      segments: traceunion,
      style: style,
    });
    //logic for preventing curve going outside plot
    let start = new Path.Line(
      new Point(padding, 0),
      new Point(padding, 600)
    );
    let interx = union.getIntersections(start);
    // console.log(interx);
    if (interx.length === 1) {
      let firstoffset = union.getOffsetOf(interx[0].point);
      let firstcut = union.splitAt(firstoffset);
      if (firstcut.segments[1].point.x < padding) {
        firstcut.opacity = 0;
      } else {
        union.opacity = 0;
      }
    }
    if (interx.length === 2) {
      let firstoffset = union.getOffsetOf(interx[0].point);
      let firstcut = union.splitAt(firstoffset);
      let secondoffset = firstcut.getOffsetOf(interx[1].point);
      let secondcut = firstcut.splitAt(secondoffset);

      if (firstcut.segments[2].point.x < padding) {
        firstcut.opacity = 0;
      } else {
        secondcut.opacity = 0;
        union.opacity = 0;
      }
    }
    let end = new Path.Line(
      new Point(padding + length, 0),
      new Point(padding + length, 600)
    );
     interx = union.getIntersections(end);
    if (interx.length === 1) {
      let firstoffset = union.getOffsetOf(interx[0].point);
      let firstcut = union.splitAt(firstoffset);
      if (firstcut.segments[1].point.x > padding + length) {
        firstcut.opacity = 0;
      } else {
        union.opacity = 0;
      }
    }
    if (interx.length === 2) {
      let firstoffset = union.getOffsetOf(interx[0].point);
      let firstcut = union.splitAt(firstoffset);
      let secondoffset = firstcut.getOffsetOf(interx[1].point);
      let secondcut = firstcut.splitAt(secondoffset);

      if (firstcut.segments[2].point.x > padding + length) {
        firstcut.opacity = 0;
      } else {
        secondcut.opacity = 0;
        union.opacity = 0;
      }
    }

    //end logic
  };
  const createText = () => {
    const Dirstring = String(Math.round(Dir)).padStart(3, "0");
    const TanAmt = Math.tan(toRadians(BetaH)) / Math.sin(toRadians(Alpha));
    const Amt = toDegree(Math.atan(TanAmt));
    const Amtstring = String(Math.round(Amt)).padStart(2, "0");
    const dipStr = "N" + Dirstring + "/" + Amtstring;

    const inputsY = Ymax + 35;
    const outputsY = Ymax + 91;

    const inputsLabel = new PointText(new Point(padding, inputsY));
    inputsLabel.justification = "left";
    inputsLabel.fillColor = "black";
    inputsLabel.fontWeight = "bold";
    inputsLabel.content = "Inputs:";

    const inputsText = new PointText(new Point(padding + inputsLabel.bounds.width + 4, inputsY));
    inputsText.justification = "left";
    inputsText.fillColor = "black";
    inputsText.content =
      "Tunnel Direction: " + D +
      "; Tunnel Inclination: " + Incl +
      "; Ch. Right SPL: " + P2 +
      "; Ch. Left SPL: " + P4;

    const inputsText2 = new PointText(new Point(padding, inputsY + 18));
    inputsText2.justification = "left";
    inputsText2.fillColor = "black";
    inputsText2.content =
      "Ch. Centerline: " + P5 +
      "; Height: " + tracedimensions.height +
      "; Width at SPL: " + tracedimensions.widthspl +
      "; Wall Height: " + tracedimensions.hw;

    const outputsLabel = new PointText(new Point(padding, outputsY));
    outputsLabel.justification = "left";
    outputsLabel.fillColor = "black";
    outputsLabel.fontWeight = "bold";
    outputsLabel.content = "Outputs:";

    const outputsText = new PointText(new Point(padding + outputsLabel.bounds.width + 4, outputsY));
    outputsText.justification = "left";
    outputsText.fillColor = "black";
    outputsText.content = "Discontinuity Dip: " + dipStr + " (Dip Direction/ Amount)";

    const cautionY = outputsY + 26;
    const cautionLabel = new PointText(new Point(padding, cautionY));
    cautionLabel.justification = "left";
    cautionLabel.fillColor = "black";
    cautionLabel.fontWeight = "bold";
    cautionLabel.content = "Caution:";

    const cautionText = new PointText(new Point(padding + cautionLabel.bounds.width + 4, cautionY));
    cautionText.justification = "left";
    cautionText.fillColor = "black";
    cautionText.content = "Discontinuity trace span may be evaluated with care in consideration of its persistence.";
  };

  const draw = (event) => {
    createScale();
    createLog();
    createTrace();
    createText();
  };
  return (
    <div id="page">
      <Header onBack={props.showinput} />
      <Footer />
      <div className="page-content header-clear-medium">
        <div className="card card-style contact-form">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                <button
                  onClick={() => props.showinput()}
                  className="btn bg-green-dark mw-2 me-3"
                >
                  Edit Input
                </button>
                <DownloadMenu
                  filename="dshape-debug"
                  screenLabel="D-shape Tunnel — Computing"
                  feedbackInputs={props.dimensions}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 overflow-auto">
                <canvas id="paper-canvas" resize="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Debugoutput;
